module.exports = __webpack_public_path__ + "img/ic_publicity_detail9_5.c3d3daed.png";